import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DataService } from "src/app/services/data.service";
import { Onderneming } from "src/app/models/Onderneming";
import { takeUntil } from 'rxjs/operators';
import { CustomLink } from '../models/CustomLink';
import { Subject } from 'rxjs';
import { CustomLinkService } from "src/app/services/custom-link.service";

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})

export class LandingPageComponent implements OnInit, OnDestroy {
 
  constructor(
    public dataService: DataService,
    private customLinkService: CustomLinkService,
    private cd: ChangeDetectorRef,
  ) {


  }
  // //Alle mogelijke modules die kunnen weergegeven worden in de applicatie
  // modules = ['vaa', 'cash4Bike', 'holidayValue','aanwerfsimulator','opzegtermijn'];

  onderneming: Onderneming;
  customLink: CustomLink;
  componentDestoryed$: Subject<boolean> = new Subject();
  isLoading:boolean=false;
  activeModules:Map<string,boolean> = new Map();

  ngOnInit(): void {
    
    this.onderneming = this.dataService.getOnderneming();
    // console.log(this.onderneming.linkLoonkost);
    if(this.onderneming.customLink.trim() != "" && this.onderneming.customLink != null)
    {
      this.getCustomLink(this.onderneming.customLink);
      console.log(this.onderneming.naam);
    }
  }
  //Laad de bijhorde Vaa van de onderneming
  getCustomLink(id: string) {

    if (this.dataService.customLink === undefined) {
      this.isLoading = true;
      this.customLinkService.getCustomLink(id).pipe(
        takeUntil(this.componentDestoryed$))
        .subscribe(e => {
          this.customLink = e;
          this.cd.markForCheck();
          this.isLoading = false;
        });

    }
    else {
      this.customLink = this.dataService.customLink;
    }
  }


 
   //Auto unsub
   ngOnDestroy() {
    this.componentDestoryed$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.componentDestoryed$.unsubscribe();
  }

}
